import { useEffect } from 'react';

export const useArchiveInteractionProtection = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return;

    const blockInteraction = (event: Event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    document.addEventListener('contextmenu', blockInteraction, true);
    document.addEventListener('dragstart', blockInteraction, true);

    return () => {
      document.removeEventListener('contextmenu', blockInteraction, true);
      document.removeEventListener('dragstart', blockInteraction, true);
    };
  }, [enabled]);
};
